import { get, find, orderBy } from 'lodash';
import { createSelector } from 'reselect';
import { parse } from 'qs';

export const FIELDS_DEFAULT_QUERY = {
  sort: 'name,asc',
};
export const RESOURCES_DEFAULT_QUERY = {
  sort: 'name,asc',
  limit: 50,
  page: 1,
};

const filterEntities = (resources = [], filters = {}) => {
  const [filtersKey] = Object.keys(filters);
  const containsText = filters[filtersKey] && filters[filtersKey].toLowerCase();

  return resources.filter(
    res => !filtersKey || res[filtersKey].toLowerCase().includes(containsText),
  );
};

const sortEntities = (resources, sort = '') => {
  const [field, order] = sort.split(',');

  return orderBy(
    resources,
    [resource => resource[field].toLowerCase()],
    [order],
  );
};

const makeGetQuery = defaultQuery =>
  createSelector(
    // NOTE: Using search instead of query intentionally,
    // to avoid additional recalculate, as query object is always new
    (state, props) => get(props, 'location.search'),
    (search = '') => {
      const parsedQuery = parse(search.substring(1));

      return { ...defaultQuery, ...parsedQuery };
    },
  );

const makeGetEntities = (entitiesSelector, defaultQuery) =>
  createSelector(
    entitiesSelector,
    makeGetQuery(defaultQuery),
    (entities, { sort, filters }) =>
      sortEntities(filterEntities(entities, filters), sort),
  );

export const getApplicationResources = createSelector(
  makeGetEntities(
    state => state.productResources.list,
    RESOURCES_DEFAULT_QUERY,
  ),
  makeGetQuery(RESOURCES_DEFAULT_QUERY),
  (sortedFilterResources, { limit, page }) => {
    const totalCount = sortedFilterResources.length;

    if (!limit || totalCount < limit) return sortedFilterResources;

    const start = (page - 1) * limit;
    const end = page * limit;
    const entitiesForPage = sortedFilterResources.slice(start, end);

    entitiesForPage.totalCount = totalCount;

    return entitiesForPage;
  },
);

export const getApplicationCurrentResource = createSelector(
  state => state.productResources.list,
  (state, modelName) => modelName,
  (resources, slug) => find(resources, { slug }) || {},
);

const getCurrentResourceFields = createSelector(
  getApplicationCurrentResource,
  ({ columns = [] } = {}) => columns,
);

export const getApplicationResourceFields = makeGetEntities(
  getCurrentResourceFields,
  FIELDS_DEFAULT_QUERY,
);
